<mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayout="column"  fxLayoutAlign="start center">
    <div fxFlex class="filter w-100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
      <mat-form-field class="accent">
        <mat-label>Search all {{ data?.data?.length ?? 0 }} homes</mat-label>
        <input matInput type="text"
          [(ngModel)]="searchTerm"
          (keyup.enter)="loadData()"
          (keyup.esc)="searchTerm=''; loadData()"
          name="searchTerm"
          placeholder="Search all {{ data?.data?.length ?? 0 }} homes">
        <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="searchTerm=''; loadData()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <div fxLayout="row" fxLayoutGap="10px">
        <button
          type="submit"
          mat-flat-button color="primary"
          (click)="loadData()"
          matTooltip="Search"
          [class.button-spinner]="loading"
          [disabled]="loading">
          <mat-icon>search</mat-icon> Search
        </button>
        <button mat-flat-button color="accent" (click)="downloadCSV()">
          Export CSV
          <mat-icon>view_list</mat-icon>
        </button>
      </div>
    </div>
    <div class="m-b-20 w-100" fxFlex="100">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <small class="text-info"><i>filter:</i></small>
        <mat-chip-list #optionChipList>
          <mat-chip *ngIf="searchTerm" class="green-chip" color="accent">
            <span>{{searchTerm}}</span>
            <button matChipRemove (click)="searchTerm = undefined; loadData();">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <!-- <mat-chip *ngIf="taggedOnly !== true"
            [matTooltip]="taggedOnly === false ? 'Showing all homes' : 'Show only Tagged homes'"
            class="green-chip"
            (click)="setTaggedOnly(false)">
            <span class="m-r-2">Non Tagged Homes</span> 
            <button matChipRemove (click)="setTaggedOnly(true)">
              <mat-icon color="basic" matTooltip="Clear filter">filter_alt</mat-icon>
            </button>
          </mat-chip>
          <mat-chip *ngIf="taggedOnly !== false"
            [matTooltip]="taggedOnly === true ? 'Showing only Tagged homes' : 'Show all homes'"
            (click)="setTaggedOnly(true)">
            <span class="m-r-2">Tagged Homes</span>
            <button matChipRemove (click)="setTaggedOnly(false)">
              <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip> -->
          <mat-chip
            [class.green-chip]="taggedOnly"
            (click)="setTaggedOnly()">
            <span class="m-r-2">Tagged Homes</span>
            <button matChipRemove (click)="setTaggedOnly()">
              <mat-icon *ngIf="!taggedOnly" color="basic" matTooltip="Filter">filter_alt_on</mat-icon>
              <mat-icon *ngIf="taggedOnly" color="basic" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
          <mat-chip
            [class.green-chip]="showOnlyVisible === true"
            (click)="toggleVisibility()">
            <span class="m-r-2">Visible Homes</span>
            <button matChipRemove (click)="toggleVisibility()">
              <mat-icon *ngIf="showOnlyVisible === undefined || showOnlyVisible === false" color="basic" matTooltip="Filter">filter_alt_on</mat-icon>
              <mat-icon *ngIf="showOnlyVisible === true" color="basic" matTooltip="Clear filter">clear</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card class="contrast" *ngFor="let item of data.data"
  [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
  <mat-card-content fxLayoutAlign="space-between center" fxLayout="row" fxLayout.lt-sm="column">
    <div fxLayoutAlign="start center" fxLayout="row" fxLayoutGap="10px">
      <!-- <img *ngIf="item?.thumbnailUrl" [src]="item.thumbnailUrl" class="thumbnail" alt="">
      <div *ngIf="!item?.thumbnailUrl" class="thumbnail banner-incomplete" alt=""></div> -->
      <strong [ngClass.lt-sm]="{'card-title': true}" [innerHtml]="item?.name | highlight: searchTerm"></strong>
      <small *ngIf="item?.home?.name">{{ item.home.name }}</small>
    </div>
    <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="4px" fxLayoutGap.lt-sm="18px">
      <mat-chip-list>
        <mat-chip *ngFor="let tag of item?.homeTags" [matTooltip]="getTagCategory(tag?.tagId)">
          {{ getTagLabel(tag?.tagId) }}
        </mat-chip>
      </mat-chip-list>
      <mat-icon 
        [color]="isRenderedThisMonth(item.dateLastRendered) ? 'accent' : ''" 
        [class.disabled-icon]="!isRenderedThisMonth(item.dateLastRendered)"
        [matTooltip]="item.dateLastRendered ? (isRenderedThisMonth(item.dateLastRendered) ? 'Rendered this month: ' : 'Last rendered: ') + formatDate(item.dateLastRendered) : 'Never rendered'">
        image
      </mat-icon>
      <mat-icon [class.raytracedplus]="isRenderedThisMonth(item.dateLastRaytracedPlusRendered)"
        [class.disabled-icon]="!isRenderedThisMonth(item.dateLastRaytracedPlusRendered)"
        [matTooltip]="item.dateLastRaytracedPlusRendered ? (isRenderedThisMonth(item.dateLastRaytracedPlusRendered) ? 'RaytracedPlus this month: ' : 'Last RaytracedPlus render: ') + formatDate(item.dateLastRaytracedPlusRendered) : 'Never RaytracedPlus rendered'">
        panorama
      </mat-icon>
      <mat-icon class="link" *ngIf="item.isHidden" mat-icon-button color="primary" matTooltip="Currently Hidden" (click)="toggleHomeVisibility(item)">visibility_off</mat-icon>
      <mat-icon class="link" *ngIf="!item.isHidden" mat-icon-button color="accent" matTooltip="Currently Visible" (click)="toggleHomeVisibility(item)">visibility</mat-icon>
    </div>
  </mat-card-content>
</mat-card>